import {getEntity} from '@ngneat/elf-entities';

import {getServiceKindDataSource} from '@store/settings/serviceKinds/serviceKinds.requests';
import {serviceKindsStore} from '@store/settings/serviceKinds/serviceKinds.store';

export class ServiceKindsQuery {
  store = serviceKindsStore;

  serviceKinds$ = getServiceKindDataSource.data$();

  serviceKindById = (serviceKindId: number) => this.store.query(getEntity(serviceKindId));
}

export const serviceKindsQuery = new ServiceKindsQuery();